export default __webpack_public_path__ + "static/media/smootie.22a84223.png";